import React from "react";
import styled from "styled-components";
import FileLabel from "./file-label";
import dayjs from "dayjs";
import { PostForm } from "./post-form";
import { t } from "../../constant/translations";
import { Editor, convertFromRaw, EditorState } from "draft-js";
import { markdownToDraft } from "markdown-draft-js";

const PostCard = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 10px;
  background: #ffffff;
`;

const PostHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
`;

const PostTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #111827;
`;

const PostMeta = styled.div`
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 8px;
`;

const PostBody = styled.div`
  font-size: 14px;
  color: #1f2937;
  line-height: 22px;
`;

const PostFiles = styled.div`
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const PostCardContent = ({ post, editButton }) => {
  return (
    <PostCard>
      <PostHeader>
        <PostTitle>{post.title}</PostTitle>
        {editButton}
      </PostHeader>
      <PostMeta>{dayjs(post.created_at).format("YYYY-MM-DD HH:mm")}</PostMeta>
      <PostBody>
        <Editor
          editorState={EditorState.createWithContent(
            convertFromRaw(markdownToDraft(post.content))
          )}
          readOnly={true}
        />
      </PostBody>
      {post.files.length > 0 && (
        <PostFiles>
          {post.files.map((fileId) => (
            <FileLabel key={`file-${fileId}`} fileId={fileId} />
          ))}
        </PostFiles>
      )}
    </PostCard>
  );
};

export const PAGE_SIZE = 1;

export const PostList = ({ posts, canEdit, page }) => {
  const pagePosts = posts.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  return (
    <div>
      {pagePosts.map((post) => (
        <PostCardContent
          key={post.id}
          post={post}
          expanded={true}
          onToggle={() => {}}
          editButton={
            canEdit && (
              <PostForm
                entity={post}
                header={t("board.change_message")}
                trigger_props={{
                  basic: true,
                  size: "mini",
                  icon: "edit",
                }}
              />
            )
          }
        />
      ))}
    </div>
  );
};
